import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import { grey } from '@material-ui/core/colors'
import Typography from '@material-ui/core/Typography'

import { ORDER_DISPLAY_MODES } from './OrderProcessor'
import { getStockAssignmentByItemIndex } from './utils'
import { range } from '~/tools/utils'

const useStyles = makeStyles((theme) => ({
    progressForOrder: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 20,
        paddingBottom: 20,
        borderBottom: '1px solid lightgray',
    },
    progressTextContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 5,
    },
    itemsRemaining: {
        fontSize: '1.3rem !important',
        marginRight: '10px !important',
    },
    itemsRemainingLabel: {
        fontSize: '1rem !important',
        color: grey[500],
    },
    progressMeter: {
        display: 'flex',
        flex: '1 0 auto',
    },
    progressMeterSegment: {
        cursor: 'pointer',
        backgroundColor: grey[300],
        marginRight: 3,
        height: 10,
        flex: '1 0 auto',
    },
    progressMeterSegmentActive: {
        cursor: 'pointer',
        backgroundColor: theme.palette.primary.main,
    },
    progressMeterSegmentSelected: {
        cursor: 'pointer',
        backgroundColor: theme.palette.secondary.main,
    },
}))

const OrderProgress = ({
    fulfillment,
    currentFulfillmentLineItemIndex,
    currentItemUnitIndex,
    orderDisplayMode,
    onItemUnitSelect,
}) => {
    const classes = useStyles()

    if (!fulfillment) {
        return null
    }

    // Calculate total items packed
    const itemsPacked = fulfillment.fulfillment_line_items.reduce(
        (total, fli) => total + fli.numPacked,
        0
    )

    // Calculate total items in order
    const totalItems = fulfillment.fulfillment_line_items.reduce(
        (total, fli) => total + fli.quantity,
        0
    )

    const requiredSerialNumberCount = fulfillment.fulfillment_line_items.reduce(
        (total, fli) =>
            fli?.stock_record?.stock_item?.stock_item_warehouse_config?.track_serial_number
                ? total + fli.quantity
                : total,
        0
    )

    return (
        <div className={classes.progressForOrder}>
            <div className={classes.progressTextContainer}>
                <Typography variant="h5" className={classes.itemsRemaining}>
                    {interpolate(pgettext('Items in order', '%s of %s'), [itemsPacked, totalItems])}
                </Typography>
                <Typography variant="h5" className={classes.itemsRemainingLabel}>
                    {gettext('items packed in this order')}
                </Typography>
                {requiredSerialNumberCount > 0 && (
                    <Typography
                        variant="h5"
                        style={{ marginLeft: 4 }}
                        className={classes.itemsRemainingLabel}
                    >
                        {interpolate('(%s items require input serial number)', [
                            requiredSerialNumberCount,
                        ])}
                    </Typography>
                )}
            </div>
            <div className={classes.progressMeter}>
                {orderDisplayMode === ORDER_DISPLAY_MODES.ONE_BY_ONE && (
                    <>
                        {fulfillment.fulfillment_line_items.map((fli, fliIndex) => {
                            return (
                                <>
                                    {range(0, fli.quantity).map((_, index) => {
                                        let isActive = false
                                        if (
                                            fli.stock_record?.stock_item
                                                ?.stock_item_warehouse_config?.track_serial_number
                                        ) {
                                            const stockAssignment = getStockAssignmentByItemIndex(
                                                fli,
                                                index
                                            )
                                            isActive =
                                                stockAssignment?.assignSerialNumberResult
                                                    ?.success ||
                                                !!stockAssignment?.physical_item?.serial_number
                                        } else {
                                            isActive = index < fli.numPacked
                                        }
                                        return (
                                            <div
                                                className={`${classes.progressMeterSegment} ${
                                                    isActive
                                                        ? classes.progressMeterSegmentActive
                                                        : ''
                                                }

                                         ${
                                             currentFulfillmentLineItemIndex === fliIndex &&
                                             currentItemUnitIndex === index
                                                 ? classes.progressMeterSegmentSelected
                                                 : ''
                                         }
                                        
                                        `}
                                                key={index}
                                                onClick={() =>
                                                    onItemUnitSelect &&
                                                    onItemUnitSelect(fulfillment, fliIndex, index)
                                                }
                                            ></div>
                                        )
                                    })}
                                </>
                            )
                        })}
                    </>
                )}

                {orderDisplayMode === ORDER_DISPLAY_MODES.ALL_AT_ONCE && (
                    <>
                        {range(
                            0,
                            fulfillment.fulfillment_line_items.reduce(
                                (total, fli) => total + fli.quantity,
                                0
                            )
                        ).map((fli, index) => {
                            const itemsPackedForOrder = fulfillment.fulfillment_line_items.reduce(
                                (total, fli) => total + fli.numPacked,
                                0
                            )

                            return (
                                <div
                                    className={classNames(classes.progressMeterSegment, {
                                        [classes.progressMeterSegmentActive]:
                                            index < itemsPackedForOrder,
                                    })}
                                    key={index}
                                ></div>
                            )
                        })}
                    </>
                )}
            </div>
        </div>
    )
}

export default OrderProgress
